export default {
  title: 'Impressum',
  subtitle: 'Personalizați detaliile afișate în Impressum-ul magazinului fără a modifica profilul afacerii.',
  defaultsNotice:
    'Fiecare câmp este opțional. Lăsați-l gol pentru a utiliza valoarea din profilul afacerii — valoarea implicită curentă este afișată în gri ca previzualizare. Completarea unui câmp suprascrie doar Impressum-ul; profilul afacerii rămâne nemodificat.',
  fields: {
    legal_name: {
      label: 'Denumire companie / juridică',
      placeholder: 'ex. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Prenume proprietar',
      placeholder: 'ex. Alex',
    },
    owner_last_name: {
      label: 'Nume proprietar',
      placeholder: 'ex. Müller',
    },
    owner_email: {
      label: 'Email',
      placeholder: 'ex. info@example.com',
      invalid: 'Introduceți o adresă de email validă',
    },
    owner_phone_number: {
      label: 'Telefon',
      placeholder: 'ex. +49 30 1234567',
    },
    tax_id: {
      label: 'CIF',
      placeholder: 'ex. DE123456789',
    },
    address: {
      label: 'Adresă',
      placeholder: 'Stradă, cod poștal, oraș',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    saved: 'Impressum salvat',
    failed: 'Salvarea Impressum-ului a eșuat',
  },
};
